import { EFrequencyType } from "../../../enums/event.enums";

export const FREQUENCY_OPTIONS = [
  { value: "eachNMinutes", label: "Every N Minutes" },
  { value: "eachNHours", label: "Every N Hours" },
  { value: "eachNDays", label: "Every N Days" },
  { value: "hourly", label: "Hourly" },
  { value: EFrequencyType.DAILY, label: "Daily" },
  { value: EFrequencyType.WEEKLY, label: "Weekly" },
  { value: EFrequencyType.MONTHLY, label: "Monthly" },
  { value: EFrequencyType.YEARLY, label: "Yearly" },
];

